// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "immutable/" + chunkId + "." + {"1806":"c1ff108a27975bea8170","8772":"9b159aead2a708dc77a6","8871":"1c0a3609523bd6391290"}[chunkId] + ".chunk.css";
};